module.exports = __webpack_public_path__ + "static/media/play-button.23f27f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-button.png
// module id = 225
// module chunks = 0